import { render, staticRenderFns } from "./HuiKuiNews.vue?vue&type=template&id=01f5f14f&scoped=true"
import script from "./HuiKuiNews.vue?vue&type=script&lang=js"
export * from "./HuiKuiNews.vue?vue&type=script&lang=js"
import style0 from "./HuiKuiNews.vue?vue&type=style&index=0&id=01f5f14f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f5f14f",
  null
  
)

export default component.exports